export default {
	path: '/',
	icon: '',
	meta: {
		title: 'ERP'
	},
	children: [
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '订单管理'
			},
			children: [
				{
					path: '/order/consult/perfect',
					name: 'PerfectIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/consult/perfect'),
					meta: {
						title: '完善报名'
					}
				},

				{
					path: '/order/consult/tobeReviewed',
					name: 'TobeReviewedIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/consult/tobeReviewed'),
					meta: {
						title: '待审核订单'
					}
				},
				{
					path: '/order/consult/rejected',
					name: 'RejectedIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/consult/rejected'),
					meta: {
						title: '被驳回订单'
					}
				},
				{
					path: '/order/consult/payOrder',
					name: 'PayOrderIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/consult/payOrder'),
					meta: {
						title: '学员支付订单'
					}
				},
				{
					path: '/order/consult/paymentList',
					name: 'paymentListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/consult/paymentList'),
					meta: {
						title: '订单列表'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '学员管理'
			},
			children: [
				{
					path: '/order/trainee/list',
					name: 'TraineeListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/list'),
					meta: {
						title: '学员列表'
					}
				},
				{
					path: '/order/phoneExamine/index',
					name: 'phoneExamineIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/phoneExamine'),
					meta: {
						title: '学员手机号审核'
					}
				},
				{
					path: '/order/fullPaymentList/index',
					name: 'fullPaymentListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/fullPaymentList'),
					meta: {
						title: '全款未完结'
					}
				},
				{
					path: '/order/overList/index',
					name: 'overListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/overList'),
					meta: {
						title: '已完结学员'
					}
				},
				{
					path: '/order/repaymentDepositList/index',
					name: 'repaymentDepositListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/repaymentDepositList'),
					meta: {
						title: '定金明细'
					}
				},
				{
					path: '/order/pendingPaymentList/index',
					name: 'pendingPaymentListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/pendingPaymentList'),
					meta: {
						title: '过补待补款'
					}
				},
				{
					path: '/order/pendingRefundList/index',
					name: 'pendingRefundListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/pendingRefundList'),
					meta: {
						title: '退费待退费'
					}
				},
				{
					path: '/order/notAshoreList/index',
					name: 'NotAshoreListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/notAshoreList'),
					meta: {
						title: '未上岸审批'
					}
				},
				{
					path: '/order/personnelChangeRecord/index',
					name: 'personnelChangeRecord',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/trainee/personnelChangeRecord'),
					meta: {
						title: '人员变动记录'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '产品管理'
			},
			children: [
				{
					path: '/order/productErp',
					name: 'ProductLookIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/productLook'),
					meta: {
						title: '产品列表'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '班次管理'
			},
			children: [
				// {
				// 	path: '/order/courseManagement',
				// 	icon: '',
				// 	ignore: true, //忽略权限校验
				// 	component: () => import('@/views/order/educationalAdministration/courseManagement'),
				// 	meta: {
				// 		title: '课程体系'
				// 	}
				// },
				// {
				// 	path: '/order/shiftManagement',
				// 	icon: '',
				// 	ignore: true, //忽略权限校验
				// 	component: () => import('@/views/order/educationalAdministration/shiftManagement'),
				// 	meta: {
				// 		title: '班次管理'
				// 	}
				// },

				// {
				// 	path: '/order/coursePlan',
				// 	icon: '',
				// 	ignore: true, //忽略权限校验
				// 	component: () => import('@/views/order/educationalAdministration/coursePlan'),
				// 	meta: {
				// 		title: '课程计划管理'
				// 	}
				// },

				{
					path: '/order/allClasses',
					name: 'AllClassesIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/allClasses'),
					meta: {
						title: '班次列表'
					}
				},
				{
					path: '/order/myClass',
					name: 'MyClassIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/myClass'),
					meta: {
						title: '我的班次'
					}
				},
				{
					path: '/order/handout-all',
					name: 'HandoutAllIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/handout-all'),
					meta: {
						title: '讲义管理'
					}
				},
				{
					path: '/order/courseSchedulingManagement-jiaowu',
					name: 'CourseSchedulingManagementJiaowuIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () =>
						import('@/views/order/educationalAdministration/courseSchedulingManagement-jiaowu'),
					meta: {
						title: '排课管理'
					}
				},
					{
					path: '/order/special_course_hours',
					name: 'ScheduleHoursIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () =>
						import('@/views/order/educationalAdministration/specialScheduling'),
					meta: {
						title: '特殊排课'
					}
				},
				{
					path: '/order/studentFeedback',
					name: 'studentFeedbackIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/studentFeedback'),
					meta: {
						title: '学生反馈'
					}
				},
				{
					path: '/order/teacherFeedback',
					name: 'teacherFeedbackIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/teacherFeedback'),
					meta: {
						title: '师资反馈'
					}
				},
				{
					path: '/order/feedadvice',
					name: 'AdviceStudentIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/adviceStudent'),
					meta: {
						title: '意见反馈-学员'
					}
				},
				{
					path: '/order/feedteacher',
					name: 'AdviceTeacherIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/adviceTeacher'),
					meta: {
						title: '意见反馈-师资'
					}
				},
				{
					path: '/order/personnel',
					name: 'PersonnelChangeIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/personnelChange'),
					meta: {
						title: '人员变动审核'
					}
				},
				{
					path: '/order/attendance',
					name: 'AttendanceFeedbackIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/AttendanceFeedback'),
					meta: {
						title: '出勤反馈'
					}
				},
				{
					path: '/order/attendanceWarning',
					name: 'attendanceWarningIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/educationalAdministration/attendance_warning'),
					meta: {
						title: '出勤预警'
					}
				},
				{
					path: '/order/lessonList',
					name: 'lectureManagement',
					icon: '',
					ignore: true,
					// component: () => import('@/views/order/educationalAdministration/lessonList'),
					component: () => import('@/views/order/educationalAdministration/lessonManagement'),
					meta: {
						title: '课时确认'
					}
				},
				// {
				// 	path: '/order/classHourStatistics',
				// 	name: 'ClassHourStatisticsIndex',
				// 	icon: '',
				// 	ignore: true,
				// 	component: () => import('@/views/order/educationalAdministration/classHourStatistics'),
				// 	meta: {
				// 		title: '课时统计'
				// 	}
				// }
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '住宿费管理'
			},
			children: [
				{
					path: '/order/accommdationList',
					name: 'AccommdationListIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/accommodationFeeManagement/accommdationList'),
					meta: {
						title: '住宿费列表'
					}
				},
				{
					path: '/order/refundAccFeeForAcademicAffairs',
					name: 'RefundAccFeeForAcademicAffairsIndex',
					icon: '',
					ignore: true,
					component: () =>
						import('@/views/order/accommodationFeeManagement/refundAccFeeForAcademicAffairs'),
					meta: {
						title: '退住宿费' //教务
					}
				}
				// {
				// 	path: '/order/refundAccFeeDepartment',
				// 	icon: '',
				// 	ignore: true,
				// 	component: () =>
				// 		import('@/views/order/accommodationFeeManagement/refundAccFeeDepartment'),
				// 	meta: {
				// 		title: '退住宿费审核' //财务
				// 	}
				// }
			]
		},
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '退费管理'
			},
			children: [
				// {
				// 	path: '/order/returnPremium/applyFor',
				// 	icon: '',
				// 	ignore: true, //忽略权限校验
				// 	component: () => import('@/views/order/returnPremium/applyFor'),
				// 	meta: {
				// 		title: '退费申请'
				// 	}
				// },
				{
					path: '/order/returnPremium/agreementRefund',
					name: 'returnPremiumApplyForIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/returnPremium/applyFor'),
					meta: {
						title: '协议退费'
					}
				},
				{
					path: '/order/returnPremium/refundDuringClass',
					name: 'refundDuringClassIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/returnPremium/refundDuringClass'),
					meta: {
						title: '课中退费'
					}
				},
				{
					path: '/order/returnPremium/depositRefund',
					name: 'depositRefIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/returnPremium/depositRefund'),
					meta: {
						title: '定金退费'
					}
				},
				{
					path: '/order/returnPremium/virtualRefund',
					name: 'virtualRefundIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/returnPremium/virtualRefund'),
					meta: {
						title: '虚拟退费'
					}
				},
				{
					path: '/order/returnPremium/refuseRefund',
					name: 'refuseRefundIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/returnPremium/rejectRefund'),
					meta: {
						title: '驳回退费'
					}
				},
				{
					path: '/order/returnPremium/examine',
					name: 'returnPremiumExamineIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/returnPremium/examine'),
					meta: {
						title: '退费审核'
					}
				},
				{
					path: '/order/returnPremium/financeExamine',
					name: 'financeExamineIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/returnPremium/financeExamine'),
					meta: {
						title: '退费审核(财务)'
					}
				}
			]
		},

		{
			path: '/',
			icon: '',
			meta: {
				title: '业绩看板'
			},
			children: [
				{
					path: '/erp/board/consultMonth',
					name: 'ConsultMonthIndex',
					icon: '',
					component: () => import('@/views/erp/board/consultMonth'),
					meta: {
						title: '咨询业绩汇总-月度'
					}
				},
				{
					path: '/erp/board/campusMonth',
					name: 'CampusMonthIndex',
					icon: '',
					component: () => import('@/views/erp/board/campusMonth'),
					meta: {
						title: '校区业绩汇总-月度'
					}
				},
				{
					path: '/erp/board/consultYear',
					name: 'ConsultYearIndex',
					icon: '',
					component: () => import('@/views/erp/board/consultYear'),
					meta: {
						title: '咨询业绩汇总-年度'
					}
				},
				{
					path: '/erp/board/campusYear',
					name: 'CampusYearIndex',
					icon: '',
					component: () => import('@/views/erp/board/campusYear'),
					meta: {
						title: '校区业绩汇总-年度'
					}
				},
				{
					path: '/erp/board/employeePerformance',
					name: 'EmployeePerformanceIndex',
					icon: '',
					component: () => import('@/views/erp/board/employeePerformance'),
					meta: {
						title: '员工绩效数据'
					}
				},
				{
					path: '/erp/board/collatePerformance',
					name: 'collatePerformanceIndex',
					icon: '',
					component: () => import('@/views/erp/board/collatePerformance'),
					meta: {
						title: '业绩核对明细'
					}
				},
				{
					path: '/erp/board/employeeFans',
					name: 'EmployeeFansIndex',
					icon: '',
					component: () => import('@/views/erp/board/employeeFans'),
					meta: {
						title: '员工粉丝数据反馈'
					}
				},
				{
					path: '/erp/board/principalRanking',
					name: 'PrincipalRankingIndex',
					icon: '',
					component: () => import('@/views/erp/board/principalRanking'),
					meta: {
						title: '负责人排名'
					}
				},
				{
					path: '/erp/board/fenPrincipalRanking',
					name: 'FenPrincipalRankingIndex',
					icon: '',
					component: () => import('@/views/erp/board/fenPrincipalRanking'),
					meta: {
						title: '分校负责人排名'
					}
				},
				{
					path: '/erp/board/performanceEducational',
					name: 'PerformanceEducationalIndex',
					icon: '',
					component: () => import('@/views/erp/board/performanceEducational'),
					meta: {
						title: '教务绩效'
					}
				},
				{
					path: '/erp/board/DisembarkBuMoney',
					name: 'DisembarkBuMoneyIndex',
					icon: '',
					component: () => import('@/views/erp/board/DisembarkBuMoney'),
					meta: {
						title: '上岸补款'
					}
				},
				{
					path: '/erp/board/personalPerSummary',
					name: 'PersonalPerSummaryIndex',
					icon: '',
					component: () => import('@/views/erp/board/personalPerSummary'),
					meta: {
						title: '个人业绩汇总'
					}
				},
				{
					path: '/erp/board/campusPerSummary',
					name: 'CampusPerSummaryIndex',
					icon: '',
					component: () => import('@/views/erp/board/campusPerSummary'),
					meta: {
						title: '校区业绩汇总'
					}
				},
				{
					path: '/erp/board/projectPerSummary',
					name: 'ProjectPerSummaryIndex',
					icon: '',
					component: () => import('@/views/erp/board/projectPerSummary'),
					meta: {
						title: '公职类型业绩汇总'
					}
				},
				{
					path: '/erp/board/projectStatistics',
					name: 'projectStatistics',
					icon: '',
					component: () => import('@/views/erp/board/projectStatistics'),
					meta: {
						title: '项目业绩汇总'
					}
				},
				{
					path: '/erp/board/targetReview',
					name: 'TargetReviewIndex',
					icon: '',
					component: () => import('@/views/erp/board/targetReview'),
					meta: {
						title: '目标审核'
					}
				},
				{
					path: '/erp/board/performanceDetail',
					name: 'performanceDetail',
					icon: '',
					component: () => import('@/views/erp/board/performanceDetail'),
					meta: {
						title: '业绩变动明细'
					}
				},
				{
					path: '/erp/board/collatePerformance',
					name: 'collatePerformanceIndex',
					icon: '',
					component: () => import('@/views/erp/board/collatePerformance'),
					meta: {
						title: '业绩核对明细-人工'
					}
				},
				{
					path: '/erp/board/performanceVerification',
					name: 'performanceVerification',
					icon: '',
					component: () => import('@/views/erp/board/performanceVerification'),
					meta: {
						title: '业绩核对明细-系统'
					}
				},
				{
					path: '/erp/board/consultant',
					name: 'consultant',
					icon: '',
					component: () => import('@/views/erp/board/consultant'),
					meta: {
						title: '咨询师'
					}
				},
				{
					path: '/erp/board/learningCenter',
					name: 'learningCenter',
					icon: '',
					component: () => import('@/views/erp/board/learningCenter'),
					meta: {
						title: '学习中心'
					}
				},
				{
					path: '/erp/board/revenueExpressReport',
					name: 'revenueExpressReport',
					icon: '',
					component: () => import('@/views/erp/board/revenueExpressReport'),
					meta: {
						title: '营收快报'
					}
				},
				{
					path: '/erp/board/summary',
					name: 'erpsummary',
					icon: '',
					component: () => import('@/views/erp/board/summary'),
					meta: {
						title: '汇总'
					}
				},
				{
					path: '/erp/board/branchSchoolProject',
					name: 'branchSchoolProject',
					icon: '',
					component: () => import('@/views/erp/board/branchSchoolProject'),
					meta: {
						title: '分校项目'
					}
				},
				{
					path: '/erp/board/branchschoolPerformance',
					name: 'branchschoolPerformance',
					icon: '',
					component: () => import('@/views/erp/board/branchschoolPerformance'),
					meta: {
						title: '分校业绩'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '教室管理'
			},
			children: [
				{
					path: '/order/ClassroomManagement',
					name: 'ClassroomManagementIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/ClassroomManagement'),
					meta: {
						title: '教室管理'
					}
				},
				{
					path: '/order/ClassroomUseManagement',
					name: 'ClassroomUseManagementIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/ClassroomUseManagement'),
					meta: {
						title: '教室统计'
					}
				}
			]
		},
		// {
		// 	path: '/order/roomList',
		// 	name: 'RoomListIndex',
		// 	icon: '',
		// 	ignore: true,
		// 	component: () => import('@/views/order/educationalAdministration/roomList'),
		// 	meta: {
		// 		title: '教室列表'
		// 	}
		// },
		{
			path: '/order/discountManagement',
			name: 'DiscountManagementIndex',
			icon: '',
			ignore: true,
			component: () => import('@/views/order/educationalAdministration/discountManagement'),
			meta: {
				title: '优惠券管理'
			}
		},

		{
			path: '/',
			icon: '',
			meta: {
				title: '印刷管理'
			},
			children: [
				// {
				// 	path: '/order/lectureManagement',
				// 	icon: '',
				// 	ignore: true,
				// 	component: () => import('@/views/order/educationalAdministration/lectureManagement'),
				// 	meta: {
				// 		title: '讲义管理'
				// 	}
				// },
				{
					path: '/order/printingFactoryManagement',
					name: 'PrintingFactoryManagementIndex',
					icon: '',
					ignore: true,
					component: () =>
						import('@/views/order/educationalAdministration/printingFactoryManagement'),
					meta: {
						title: '印刷厂管理'
					}
				},
				{
					path: '/order/printingRecordManagement',
					name: 'PrintingRecordManagementIndex',
					icon: '',
					ignore: true,
					component: () =>
						import('@/views/order/educationalAdministration/printingRecordManagement'),
					meta: {
						title: '印刷记录管理'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '试卷管理'
			},
			children: [
				{
					path: '/order/testPaperManagement',
					name: 'testPaperManagementIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/testPaperManagement'),
					meta: {
						title: '试卷列表'
					}
				},
				{
					path: '/order/answerList',
					name: 'AnswerListIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/answerList'),
					meta: {
						title: '答题列表'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '酒店管理'
			},
			children: [
				{
					path: '/order/hotelList',
					name: 'HotelListIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/hotelManagement/hotelList'),
					meta: {
						title: '酒店列表'
					}
				}
			]
		}
	]
}
